module.exports = __webpack_public_path__ + "static/img/14001012.a58898cb.png";